import * as React from "react";
import { Box, TableCell, TableHead, TableRow, TableSortLabel, } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
export function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (React.createElement(TableHead, null,
        React.createElement(TableRow, null, props === null || props === void 0 ? void 0 : props.headCells.map((headCell) => (React.createElement(TableCell, { key: headCell.id, sortDirection: orderBy === headCell.id ? order : false, className: "headercellColor tableHeader", sx: { zIndex: "auto" } },
            React.createElement(TableSortLabel, { active: orderBy === headCell.id, direction: orderBy === headCell.id ? order : "asc", onClick: createSortHandler(headCell.id), className: "headercellColor tableHeader" },
                headCell.label,
                orderBy === headCell.id ? (React.createElement(Box, { component: "span", sx: visuallyHidden }, order === "desc" ? "sorted descending" : "sorted ascending")) : null)))))));
}
